export default {
  "content": "<g clip-path=\"url(#7_svg__clip0)\" opacity=\".2\"><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M10 0l30 15 2 1V2.2c0-.8 0-1.5-.2-2.2h-2.1c.2.7.3 1.4.3 2.2v10.6L14.5 0H10zm31.8 24a10 10 0 00-5.3-6.8L4 1 2 0v13.8a10 10 0 005.5 9L10 24h4.5l-6-3A8 8 0 014 13.8V3.2L35.6 19a8 8 0 014.1 5h2zM78 24l2.5-1.2a10 10 0 005.5-9V0l-2 1-32.5 16.2a10 10 0 00-5.3 6.8h2.1a8 8 0 014.1-5L84 3.2v10.6a8 8 0 01-4.4 7.2l-6 3H78zm0-24L48 15l-2 1V2.2c0-.8 0-1.5.2-2.2h2.1a8 8 0 00-.3 2.2v10.6L73.5 0H78z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"7_svg__clip0\"><path fill=\"#fff\" d=\"M0 0h88v24H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "88",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 88 24"
  }
};